module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: ['map-wrap', {
      'shift-right': _vm.shiftMap
    }],
    on: {
      "click": _vm.clearDestinations
    }
  }, [_c('svg', {
    attrs: {
      "viewBox": _vm.viewBox,
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "height": "100%",
      "width": "100%"
    }
  }, [_c('map-image'), _vm._v(" "), _c('image', {
    attrs: {
      "width": "90",
      "height": "99",
      "transform": ("translate(13, -19.5) scale(" + (_vm.pxToSvgSize(90) / 90) + ")"),
      "xlink:href": require("@/assets/images/current_location.svg")
    }
  })], 1), _vm._v(" "), (_vm.visualizationLayerType === 'congestion') ? _c('visualization-layer-congestion') : _vm._e(), _vm._v(" "), _c('svg', {
    staticClass: "visualizationPinLayer",
    attrs: {
      "viewBox": _vm.viewBox,
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "height": "100%",
      "width": "100%"
    }
  }, [_c('svg-defs'), _vm._v(" "), (_vm.visualizationLayerType == 'setstar') ? _c('visualization-layer-setstar') : _vm._e(), _vm._v(" "), (_vm.visualizationLayerType == 'sound') ? _c('visualization-layer-sound') : _vm._e(), _vm._v(" "), (_vm.includesSpotsPin) ? _c('visualization-pin-spot') : _vm._e(), _vm._v(" "), (_vm.includesPersonsPin) ? _c('visualization-pin-person') : _vm._e()], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c9121882","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/map/map.vue
// module id = 772
// module chunks = 0